
import { supabase } from '@/integrations/supabase/client';
import { generateAnonymousId } from '@/utils/anonymousId';
import { ContentType } from '@/services/comments/types';

/**
 * Records a share action in the database
 */
export const recordShare = async (
  contentId: string,
  userId: string | null,
  anonymousId: string | null,
  platform: string = 'direct',
  contentType: ContentType = 'card'
): Promise<boolean> => {
  try {
    if (!contentId) {
      console.error('No content ID provided for recording share');
      return false;
    }

    // Insert based on content type
    if (contentType === 'poll') {
      const { error } = await supabase
        .from('poll_shares')
        .insert({
          poll_id: contentId,
          platform,
          user_id: userId,
          anonymous_id: anonymousId
        });

      if (error) {
        console.error('Error recording poll share:', error);
        return false;
      }
    } else {
      const { error } = await supabase
        .from('card_shares')
        .insert({
          card_id: contentId,
          platform,
          user_id: userId,
          anonymous_id: anonymousId
        });

      if (error) {
        console.error('Error recording card share:', error);
        return false;
      }
    }
    
    return true;
  } catch (error) {
    console.error('Error recording share:', error);
    return false;
  }
};

/**
 * Fetches the shares count for a content item
 */
export const fetchSharesCount = async (contentId: string, contentType: ContentType = 'card'): Promise<number> => {
  try {
    if (contentType === 'poll') {
      const { count, error } = await supabase
        .from('poll_shares')
        .select('*', { count: 'exact', head: true })
        .eq('poll_id', contentId);
      
      if (error) {
        console.error('Error fetching poll shares count:', error);
        return 0;
      }
      
      return count || 0;
    } else {
      const { count, error } = await supabase
        .from('card_shares')
        .select('*', { count: 'exact', head: true })
        .eq('card_id', contentId);
      
      if (error) {
        console.error('Error fetching card shares count:', error);
        return 0;
      }
      
      return count || 0;
    }
  } catch (error) {
    console.error('Error fetching shares count:', error);
    return 0;
  }
};
